import { BehaviorSubject } from 'rxjs';

export class ToggleSubject extends BehaviorSubject<boolean> {
  constructor(value?: boolean) {
    super(!!value);
  }

  toggle(): void {
    this.next();
  }

  next(override?: boolean) {
    super.next(override ?? !this.value);
  }
}
